export class Base64Utils {
	static encode(value: any): string {
		return btoa(unescape(encodeURIComponent(JSON.stringify(value))));
	}

	static decode(value: string): any {
		return JSON.parse(decodeURIComponent(escape(atob(value))));
	}
}